module.exports = "/8/1-toan-tu-tang-giam-dung-cho-con-tr/index.html.cce9500249671524aec88406806baa9e.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30699.md
 ** module id = 567
 ** module chunks = 0
 **/